// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qy-2";
export var chatLink = "_qy-0";
export var chatText = "_qy-1";